import * as React from "react";
const SvgHide = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#hide_svg__a)">
      <path
        fill="#062147"
        d="M23.27 9.42a15.9 15.9 0 0 0-3.37-3.91l2.8-2.8a1 1 0 0 0-1.414-1.414l-3.045 3.05A12.05 12.05 0 0 0 12 2.655c-6.191 0-9.72 4.237-11.271 6.763a4.91 4.91 0 0 0 0 5.162 15.9 15.9 0 0 0 3.37 3.91l-2.8 2.8a1 1 0 1 0 1.415 1.413l3.052-3.052A12.05 12.05 0 0 0 12 21.345c6.19 0 9.719-4.238 11.27-6.764a4.91 4.91 0 0 0 0-5.162M2.434 13.533a2.92 2.92 0 0 1 0-3.068C3.767 8.3 6.782 4.656 12 4.656a10.1 10.1 0 0 1 4.766 1.164l-2.013 2.013a4.992 4.992 0 0 0-6.92 6.92l-2.31 2.31a13.7 13.7 0 0 1-3.09-3.529M15 12a3 3 0 0 1-3 3 2.95 2.95 0 0 1-1.285-.3l3.985-3.985c.195.4.298.84.3 1.285m-6 0a3 3 0 0 1 3-3 2.95 2.95 0 0 1 1.285.3L9.3 13.285c-.196-.4-.299-.84-.3-1.285m12.567 1.534c-1.334 2.166-4.35 5.811-9.567 5.811a10.1 10.1 0 0 1-4.766-1.165l2.013-2.013a4.992 4.992 0 0 0 6.92-6.92l2.31-2.31c1.224.99 2.27 2.184 3.09 3.53a2.92 2.92 0 0 1 0 3.067"
      />
    </g>
    <defs>
      <clipPath id="hide_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHide;
